gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {

  // Fade-in elements
  gsap.utils.toArray(".fade-in").forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      y: 40,
      duration: 3.0,
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none none",
      }
    });
  });

  // Pixelated reveal 
  gsap.utils.toArray(".pixel-reveal").forEach((el) => {
    gsap.fromTo(el,
      { filter: "blur(12px)", opacity: 0 },
      {
        filter: "blur(0px)",
        opacity: 1,
        duration: 5.0,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
        }
      }
    );
  });

  // Text “slide up” reveal
  gsap.utils.toArray(".text-reveal").forEach((el) => {
    gsap.from(el, {
      y: 60,
      opacity: 0,
      duration: 2.0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 90%"
      }
    });
  });

});

// Split Screen Reveal
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".split-screen-reveal").forEach((section) => {
  
  const text = section.querySelector(".split-animate-left");
  const image = section.querySelector(".split-animate-right");

  gsap.to(text, {
    x: 0,
    opacity: 1,
    duration: 1.2,
    ease: "power3.out",
    scrollTrigger: {
      trigger: section,
      start: "top 85%",
      toggleActions: "play none none none"
    }
  });

  gsap.to(image, {
    y: 0,
    opacity: 1,
    duration: 3.0,
    ease: "power3.out",
    scrollTrigger: {
      trigger: section,
      start: "top 80%"
    }
  });

});

// Text Reveal Story Blocks
gsap.utils.toArray(".story-block").forEach((block) => {
  gsap.to(block, {
    opacity: 1,
    y: 0,
    duration: 2.0,
    ease: "power3.out",
    scrollTrigger: {
      trigger: block,
      start: "top 85%",
      toggleActions: "play none none none"
    }
  });
});

// ===============================
// Scroll Image List Reveal
// ===============================
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  const items = document.querySelectorAll("[data-scroll-image-item]");

  items.forEach((item) => {
    gsap.fromTo(
      item,
      { autoAlpha: 0, y: 80 },
      {
        autoAlpha: 1,
        y: 0,
        ease: "power2.out",
        duration: 1,
        scrollTrigger: {
          trigger: item,
          start: "top 85%",
          end: "bottom 60%",
          toggleActions: "play none none reverse"
        }
      }
    );
  });
});
